module.exports = __webpack_public_path__ + "img/2.68c5b5f2.jpg";